import { strings } from '../../../i18n'
import store from '../../../redux/index'
import { modalErrorAction } from '../../../redux/stores/MobileExchanger/action'

const { dispatch } = store

const findOutDestination = (walletData, outCurrency, cashbackToken) => {
    const result = {}
    
    if (!walletData) {
        dispatch(modalErrorAction(true, strings('mobileExchanger.modal.serverRespond')))
        result.outDestination = null
        result.walletName = null
        return result
    }

    const activeWallet = walletData.wallets.find(wallet => wallet.cashbackToken === cashbackToken)
    if (!activeWallet) { return null }
    result.walletName = activeWallet.walletName
    const activeAccount = activeWallet.accounts.find(account => account.currencyCode === outCurrency)
    if (!activeAccount) { return null }

    if (typeof activeAccount.address === 'string') {
        result.outDestination = activeAccount.address
        return result
    } else {
        result.outDestination = activeAccount.address.find(address => address.type === 'SEGWIT').address
        return result
    }
}

export default findOutDestination